// window.postMessage('','*')
// window.postMessage({wdma: true, name: 'init', data: {email: 'rodrigo.moriama@cma.com.br', password: 'cma123'}})
// window.postMessage({wdma: true, name: 'logout'})
// window.postMessage({wdma: true, name: 'displaySystem', data: true})
// window.postMessage({wdma: true, name: 'navigate', data: {commodityId: 0}});
// window.postMessage({dev: true, name: 'displayState', data: 'fieldName'});
// window.postMessage({dev: true, name: 'toggleMenu', data: true})

// window.postMessage({wdma: true, name: 'checkCookiesAccepted'});
// window.postMessage({wdma: true, name: 'getAcceptorRefreshToken'});
// window.postMessage({wdma: true, name: 'checkAcceptorToken'});
// window.postMessage({wdma: true, name: 'acceptorRefreshToken', data: {refresh_token: ""}});
import store from '@/store/store';
import formatFieldHelper from '../../helpers/format-field-helper';
import authService from '../../providers/authService';
import acceptorService from '../../providers/acceptorService';
import { EventBus } from '../../event-bus';
import AppConstants from '../../appConstants';
import Vue from 'vue';

self.onmessage = function (e) {
    // console.log('postMessage received');
    // console.log(e.data);
    if (e.data.name) {
        acceptedFunctions[e.data.name](e.data.data ? e.data.data : null);
    }
    // if (e.data.wdma || e.data.dev) {}
}

const acceptedFunctions = {
    // isBiometryAvailable(payload) {
    //     store.state.dispatch('updateHasBiometry', payload == 'true');
    // },
    // getBiometrySecret(payload) {
    //     store.state.dispatch('updateBiometrySecrets', payload);
    // },
    // saveBiometrySecretStatus(payload) {
    //     if (payload == 'true') store.state.dispatch('updateSaveBiometrySecretsStatus', 'success');
    //     else store.state.dispatch('updateSaveBiometrySecretsStatus', 'error');
    // },
    pushNotification(payload) {
        // window.postMessage({name: 'pushNotification', data: {id: '67990de0e93ac44780fb1dfb', action: 'openPage', commodity: 0}})
        console.log(`[postMessage][pushNotification] payload received: `, JSON.stringify(payload));
        if (payload.action === 'openPage') {
            console.log(`[postMessage][pushNotification] open news detail with id ${payload.id}`);
            EventBus.$emit(AppConstants.BUS_EVENT_OPEN_NEWS_DETAIL, payload);
        }
    },
    init(data) {
        // login with token
        const form = {
            email: data.email,
            password: data.password
        };
        authService
            .login(form, new URLSearchParams())
            .then(response => {
                response[0].email = form.email;
                authService.successLogin(response, false);
                this.displaySystem(true);
            })
            .catch(error => {
                console.log(error);
            });
    },
    logout() {
        console.log('logout');
        authService.logout();
        this.displaySystem(false);
    },
    displaySystem(val) {
        store.commit('UPDATE_DISPLAY_SYSTEM', val);
    },
    setLayout(data) {
        console.log('setLayout');
    },
    navigate(val) {
        console.log('navigate');
        store.dispatch('updateCurrentCommodity', val);
    },
    toggleMenu(val) {
        console.log('toggleMenu: ', val);
        EventBus.$emit(AppConstants.BUS_EVENT_TOGGLE_REDUCE_MAIN_MENU, val);
    },
    testValidateCpf(val) {
        console.log('testValidateCpf');
        console.log(formatFieldHelper.validateCPF(val));
    },
    testValidateCnpj(val) {
        console.log('testValidateCnpj');
        console.log(formatFieldHelper.validateCNPJ(val));
    },
    displayState(field) {
        console.log(`displayState[${field}]`);
        console.log(store.state[field]);
    },
    acceptorNewToken() {
        acceptorService
            .requestNewToken({ ua: navigator.userAgent }, new URLSearchParams())
            .then(data => {
                console.log('[acceptor][newToken]', data);
            })
            .catch(error => {
                console.log("Error on request a new token", error);
            })
    },
    acceptorRefreshToken(refresh_token) {
        acceptorService
            .refreshToken({ refresh_token }, new URLSearchParams())
            .then(data => {
                console.log('[acceptor][refreshtoken]', data);
            })
            .catch(error => {
                console.log("Error on refresh token", error);
            });
    },
    checkAcceptorToken() {
        EventBus.$emit(AppConstants.BUS_EVENT_CHECK_ACCEPTOR_TOKEN);
    },
    getCurrentUserData(field) {
        console.log(JSON.parse(localStorage.getItem('currentUser'))[field]);
    },
    getAcceptorToken() {
        console.log(JSON.parse(localStorage.getItem('currentUser'))['acptoken']);
    },
    getAcceptorRefreshToken() {
        console.log(JSON.parse(localStorage.getItem('currentUser'))['refresh_token']);
    },
    checkCookiesAccepted() {
        console.log("Cookies Accepted:", Vue.$cookies.get('cookies_accepted'));
    }
}